import Vue from 'vue'
import { RELEVANCE_INTERVAL, LOCAL_STORE_NAMES } from '@/constants/settings.js'
import { URL_RELEVANCE_FILE } from '@/constants/urls.js'
import { RELEVANCE, AXIOS_REQUESTS } from '@/constants/store.js'

const init = Vue.helpers.getFromLocalStorage(LOCAL_STORE_NAMES.RELEVANCE)

const state = {
  [RELEVANCE.STATE.RELEVANCE]: init ? init.relevance || '' : '',
  [RELEVANCE.STATE.NEED_RELOAD_PAGE]: false
}

const actions = {
  async [RELEVANCE.ACTIONS.CHECK_RELEVANCE] ({ commit, dispatch, state }) {
    const model = {
      url: `${URL_RELEVANCE_FILE}?${Vue.helpers.getQueryParamsString()}`,
      settings: { timeout: RELEVANCE_INTERVAL / 2 }
    }

    try {
      const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })

      if (resp && resp.data) {
        if (!state.relevance && resp.data.relevance) {
          commit(RELEVANCE.MUTATIONS.SET_RELEVANCE, resp.data.relevance)
        } else if (state.relevance !== resp.data.relevance) {
          commit(RELEVANCE.MUTATIONS.SET_RELEVANCE, resp.data.relevance)
          commit(RELEVANCE.MUTATIONS.SET_NEED_RELOAD_PAGE)
        }
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
    }
  },
  async [RELEVANCE.ACTIONS.SET_NEED_RELOAD_PAGE] ({ commit, dispatch, state }, need) {
    commit(RELEVANCE.MUTATIONS.SET_NEED_RELOAD_PAGE, need)
  }
}

const mutations = {
  [RELEVANCE.MUTATIONS.SET_RELEVANCE] (state, relevance) {
    state[RELEVANCE.STATE.RELEVANCE] = relevance
    Vue.helpers.saveToLocalStorage(LOCAL_STORE_NAMES.RELEVANCE, { relevance })
  },
  [RELEVANCE.MUTATIONS.SET_NEED_RELOAD_PAGE] (state, need = true) {
    // раскомментировать, когда в окончательном варианте
    state[RELEVANCE.STATE.NEED_RELOAD_PAGE] = need
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
